import {inject, injectable} from 'inversify';

import type {CategoryApiModel} from '../../../../api/category';
import type {FileApiModel} from '../../../../api/media/file';
import type {Expand, MaybeExpanded} from '../../../../api/types';

import {EnvProviderService} from '../../../system/env/EnvProvider.service';
import {BaseExpandJrpc} from '../../Base/mappers/Base.expand.jrpc';

@injectable()
export class ArticleExpandJrpc extends BaseExpandJrpc {
  constructor(@inject(EnvProviderService) env: EnvProviderService) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = {
      article: ['avatar_id', 'attachment_ids', 'categories.category_id'],
    };
    const core: Expand = base;
    const b2b: Expand = base;

    return this.resolve({b2b, core, key});
  }
}

export namespace ArticleExpandJrpc {
  export type ExpandedFields = {
    attachments: MaybeExpanded<FileApiModel>[];
    avatar: MaybeExpanded<FileApiModel>;
    categories: {
      category: MaybeExpanded<CategoryApiModel>;
      category_id: string;
      weight: number;
    }[];
  };
}
